import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_NATURA_GIURIDICA } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeNaturaGiuridicaAction,
  storeRolesAction,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const retrieveNaturaGiuridicaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_NATURA_GIURIDICA),
    map(() => ({
      page: 1,
      pageSize: rootConfig.populateFields,
      order: [['nome', 'asc']],
    })),
    // tap(p => console.log(`[epic ${RETRIEVE_NATURA_GIURIDICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        of(setListConfigAction({ role: body })),
        defer(() =>
          from(
            request({
              path: `naturaGiuridica/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_NATURA_GIURIDICA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeNaturaGiuridicaAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_NATURA_GIURIDICA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default retrieveNaturaGiuridicaEpic;
